// removed by extract-text-webpack-plugin
module.exports = {"xxsmall":"GroupAvatar__xxsmall___2SP_o","xsmall":"GroupAvatar__xsmall___1t6_6","small":"GroupAvatar__small___C7ODj","medium":"GroupAvatar__medium___tv_mW","large":"GroupAvatar__large___3U2FZ"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupAvatar.css
// module id = 1324
// module chunks = 4